export class EkycOtpRequest {
  mobileNo: string;
  token: string;
  customerName: string;
  redirectURL: string;
  otp: any;
}

export class EKycBasicData {
  token: any;
	customerName: string;
  mobileNo: string;
  redirectURL: string;
  appName: string;
  errMsg: string;
}

export class GenerateOtpDetails {
	errMsg: string;
  smsStatus: string;
}